import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=b6143484&scoped=true"
import script from "./ClientView.vue?vue&type=script&lang=js"
export * from "./ClientView.vue?vue&type=script&lang=js"
import style0 from "./ClientView.vue?vue&type=style&index=0&id=b6143484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6143484",
  null
  
)

export default component.exports